(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ayudra-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var desktop = window.matchMedia('(min-width: 768px)');
    function syncFooter() {
      var isDesktop = desktop.matches;
      document.querySelectorAll('[data-footer-col]').forEach(function (el) {
        if (isDesktop) {
          el.setAttribute('open', '');
        } else {
          el.removeAttribute('open');
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncFooter);
    } else {
      syncFooter();
    }

    window.addEventListener('resize', syncFooter);
    if (desktop.addEventListener) {
      desktop.addEventListener('change', syncFooter);
    }
    document.addEventListener('shopify:section:load', syncFooter);
  })();

  } catch(e) { console.error(e); }
})();
})();
